import React, { useState,useEffect } from "react";
import { useLocation } from 'react-router-dom'
const Search = ({ onSearch }) => {
    const [search, setSearch] = useState("");

    const { pathname } = useLocation();
    useEffect(() => {
        setSearch(""); 
      }, [pathname])

    const onInputChange = value => {
        setSearch(value);
        onSearch(value);
    };
    return (
        <input
            type="text"
            className="form-control"
            style={{ width: "240px" }}
            placeholder="Search"
            value={search}
            onChange={e => onInputChange(e.target.value)}
        />
    );
};

export default Search;
